export const topLeft = 'topLeft' as const
export const topCenter = 'topCenter' as const
export const topRight = 'topRight' as const
export const centerLeft = 'centerLeft' as const
export const centerCenter = 'centerCenter' as const
export const centerRight = 'centerRight' as const
export const bottomLeft = 'bottomLeft' as const
export const bottomCenter = 'bottomCenter' as const
export const bottomRight = 'bottomRight' as const

const referencePoints = [
  topLeft,
  topCenter,
  topRight,
  centerLeft,
  centerCenter,
  centerRight,
  bottomLeft,
  bottomCenter,
  bottomRight
] as [
  typeof topLeft,
  typeof topCenter,
  typeof topRight,
  typeof centerLeft,
  typeof centerCenter,
  typeof centerRight,
  typeof bottomLeft,
  typeof bottomCenter,
  typeof bottomRight
]

export type ReferencePoint = Unpacked<typeof referencePoints>

export type ReferencePoints<P = [number, number]> = {
  [key in ReferencePoint]: P
}

export default referencePoints

export type Octant =
  | -13
  | -12
  /** left bottom back */
  | -11
  /** left bottom */
  | -10
  /** bottom */
  | -9
  /** bottom right */
  | -8
  /** front bottom left */
  | -7
  /** front bottom */
  | -6
  /** front right bottom */
  | -5
  /** back left */
  | -4
  /**  back [0, -, 0] */
  | -3
  /** front left [-, +, 0] */
  | -2
  /** left [-, 0, 0] */
  | -1
  /** center 0 | 0 | 0 */
  | 0
  /** right [+, 0, 0]  */
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
